import stringSubstitute from "../utils/stringSubstitute";

let texts = {}

export const registerSource = (aSource) => {
  for (var s in aSource) {
    texts[s] = aSource[s];
  }
}

export default function TextSubstitution(template) { return stringSubstitute(template, texts); }
